<script>
  import { onMount, afterUpdate } from 'svelte';
  import { Chart as ChartJS, BarController, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

  // Register required components for the chart
  ChartJS.register(
    BarController,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  export let type = "bar"; // The chart type
  export let data = {};    // The chart data
  export let options = {}; // The chart options

  let chartCanvas; // Reference to the canvas element
  let chartInstance = null; // Chart instance that will be used for updates

  // Function to create the chart
  function createChart() {
    chartInstance = new ChartJS(chartCanvas, {
      type,       // Bar chart type
      data,       // Chart data
      options     // Chart options
    });
  }

  // Function to update the chart when data or options change
  function updateChart() {
    if (chartInstance) {
      chartInstance.data = data; // Update the chart data
      chartInstance.options = options; // Update the chart options
      chartInstance.update(); // Refresh the chart
    }
  }

  // Initialize chart when the component is mounted
  onMount(() => {
    createChart(); // Create the chart when the component is mounted

    // Clean up the chart instance when the component is destroyed
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  });

  // Update the chart whenever `data` or `options` change
  afterUpdate(() => {
    updateChart(); // Re-render the chart with the new data
  });
</script>

<canvas bind:this={chartCanvas}></canvas>
